import React from 'react';
import PatientRecallTimeline from '../../PatientRecall/PatientRecallTimeline/PatientRecallTimeline';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core';

const styles = makeStyles({
  timelineWrapper: {
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column'
  }
});

const RecallAnalysisContainer = (): JSX.Element => {
  // FIXME: ADD PROPER TYPES
  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );
  const selectedPatient = useSelector(
    (state: any) => state.patientDetailsDrawer.patientDetails
  );
  const classes = styles();
  return (
    <div className={`${classes.timelineWrapper} patient-drawer-content`}>
      <PatientRecallTimeline
        groupId={patientDetailsDrawer?.groupId}
        clinicId={patientDetailsDrawer?.clinicId}
        patientId={patientDetailsDrawer?.patientId}
        selectedPatient={selectedPatient}
      />
    </div>
  );
};

export default RecallAnalysisContainer;
